<template>
    <div id="item-container">
        <b-row>
            <b-col>
                <MdTitle 
                    v-bind:Text="this.editMode ? $t('TestPanelSetupL.EditPanelSetup'): $t('TestPanelSetupL.AddPanelSetup')"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12" v-if="false">
                <MdEdit 
                    v-bind:Label="$t('Shared.Code')"
                    v-bind:Name="'Code'"
                    v-bind:TypeProp="'text'"  
                    v-bind:MaxLengthProp="15"     
                    v-model="objecResultObj.code"
                    v-bind:isReadOnly="isReadOnly || editMode"
                    v-bind:Id="'input_code'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('TestPanelSetupL.GroupName')"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'groupName'"
                    v-bind:MaxLengthProp="100"
                    v-model="objecResultObj.groupName"
                    v-bind:Id="'input_description'">                                     
                </MdEdit>
            </b-col>
            
             <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Loinc'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'Loinc'"
                    v-model="objecResultObj.loincCode"
                    v-bind:Id="'input_loin'"
                    v-bind:MaxLengthProp="100">                                     
                </MdEdit>
            </b-col>
               <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'SNOMED'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Name="'snoMedCode'"
                    v-model="objecResultObj.snoMedCode"
                    v-bind:Id="'input_snomed'"
                    v-bind:MaxLengthProp="100">                                     
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:ModelCode="objecResultObj.cptcode"
                    v-bind:ModelDescription="dcpt"
                    v-bind:Label="$t('Shared.CPT')"
                    v-bind:RefCode="'cpt'"                     
                    v-bind:Api="'cpts'"
                    v-bind:FieldCode="'code'"                    
                    v-bind:FieldDescription="'name'"
                    :SearchTitle="$t('Shared.CPT')"
                    :GetValues="onCodeConditionOk"
                    :InvalidFeedback="$t('rooms.cptRequired')"
                    :SearchFieldCode="'code'"
                />
            </b-col>
        </b-row>
        <b-row>
           
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.UnitPrice')"
                    v-bind:TypeProp="'number'" 
                    v-bind:Name="'unitPrice'"
                    v-bind:Min="'0'"
                    v-bind:StepProp="'0.01'"
                    v-model="objecResultObj.unitPrice"
                    v-money-prefix                      
                    v-bind:Id="'input_unitPrice'">                                                        
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdCheckBox
                  v-bind:Label="$t('Shared.Inactive')"
                  v-bind:Name="'Inactive'"
                  v-bind:ClassProp="'AlignCheck'"
                  v-bind:CheckedValue="true"
                  v-bind:UncheckedValue="false"
                  v-model="objecResultObj.isInactive"                 
               />
            </b-col>   
        </b-row>

         <b-row>
            <b-col sm="12" class="mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.Details')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdButton
                    v-bind:Label="$t('Shared.Add')"
                    v-bind:ClassProp="
                        this.isReadOnly
                            ? 'btn btn-primary my-3 btn-block'
                            : 'btn btn-primary my-3 btn-block btn-login'
                    "
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-bind:isReadOnly="this.isReadOnly"
                >
                </MdButton>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <MdTablePaginationClient
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:IsItemReceived="true"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                >
                </MdTablePaginationClient>
                <!--
                <MdEditableGrid
                    :ref="'editableGrid'"
                    v-bind:fields="fields"
                    v-model="items"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:header="true"
                    v-bind:edit="editAction"
                    :add="addAction"
                    :totalRows.sync="totalRows"
                    :validateRowCallback="validateRowHandler"
                >
                </MdEditableGrid>
            -->
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')" 
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly=this.isReadOnly
                v-bind:Name="'btn_save_inventory_item'"
            />
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import TestPanelSetupService from '@/services/testpanelsetup.service';
import CPTService from '@/services/cpt.service'


let elemSaveBtn = '';    
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$t('TestPanelSetupL.Title'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(value => {
                if(!value){
                    next();
                } else {
                    this.SaveOrEdit();
                    next();
                }
            })		
        } else {
            next()
        }
    },

    mixins: [ShowMessage, DBFunctions],
    props: {
        editMode: Boolean,
    },
    data() {
        return {
           
            OptionsRightMenu:{
                visible:false,
                ItemsList:[],
                btnvisible:false,
                itemdisabled: false,
                Mode:this.editMode,
                favButtonAtion:false          
            },

            isReadOnly: false,
            isEditable: true,
            objecResultObj : {
                code: '',
                groupName: '',
                loincCode: '',
                isInactive: false,
                snoMedCode: '',
                cptcode: '',
                unitPrice: null
            },
            dcpt: '',
            fields: [
                { key: 'name', sortable: true, label: this.$t('Shared.Name'), class: 'text-left' },
                { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-right' },
                { key: 'cptcode', sortable: true, label: this.$t('DrugInventoryItem.CPTCode'), class: 'text-right' },
                { key: 'longName', sortable: true, label:  this.$t('TestOrdersResultSetupL.LongD'), class: 'text-left' },
            ],
            totalRows: 0,
            showMessageIsEmpty: false,
            pageOptions: [5, 10, 15],
            perPage: 10,
            currentPage: 1,
            items: [],
        }
    },

    methods: {
       
        onCodeConditionOk(result) {
            var type = result.FieldName;
            if (type.indexOf('cpt') >= 0) {
                this.dcpt = result.description;
                this.objecResultObj.cptcode = result.code;
            } 
        },

        getAllDescription(){
            if(this.objecResultObj.cptcode){
                const CptParam = {
                    code : this.objecResultObj.cptcode
                };
                CPTService.getCPTByCode(CptParam)
                    .then((response) => {
                        
                        if(response.status == '200' && response.data.length > 0){
                            this.dcpt = response.data[0].name;
                        } 
                    })
                    .catch((error) => {   
                        this.showResponseErrorMessage(error);
                    }); 
            }
        },

        goBack() {
            this.$router.push({ name: 'TestPanelSetupListing' });
        },

        SaveOrEdit() {
            if(!this.isReadOnly) {
                elemSaveBtn.setAttribute("disabled",'');

                if (this.editMode) { 
                    this.update();
                } else {            
                    this.save();
                }
            }
        },

        save() {
            TestPanelSetupService
                .add(this.objecResultObj)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                            , 50); 

                        this.goBack();
                    }
                })
                .catch((error) => {
                    elemSaveBtn.removeAttribute("disabled");
                    this.showResponseErrorMessage(error);
                });
        },

        update() {
            TestPanelSetupService
                .update(this.$route.params.id, this.objecResultObj)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                            , 50); 

                        this.goBack();
                    }
                })
                .catch((error) => {
                    elemSaveBtn.removeAttribute("disabled");
                    this.showResponseErrorMessage(error);
                });
        },

        getTestOrderResult(){
            if(this.editMode){
                TestPanelSetupService.get(this.$route.params.id)
                    .then((response) => {
                        if(response.status == '200' && response.data){
                            this.objecResultObj = response.data
                            this.getAllDescription();
                        }   
                    })
                    .catch((error) => {                    
                        this.showResponseErrorMessage(error);          
                    }); 
            }
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        pageChanged(page) {
            this.currentPage = page;
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
        },

        onRowSelected() {},

        beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
            }
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },
    },

    async mounted() {

        this.getTestOrderResult();
        setTimeout( function() {
            elemSaveBtn = document.getElementById('btn_save_inventory_item');
            elemSaveBtn.setAttribute('disabled','');
        }, 50, this );
    },

    created() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        EventBus.$on("onChanged", function (e) {       
            this.pendingChanges = e.Changed
            this.checkUserAction();
        }.bind(this));
    
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
}
</script>